import React from 'react';
import { Progress } from 'antd';
import './SverviceCompletionAnalytics.less';
import { renderPerStr } from '@/utils/renderUtils';
import i2Math from '@/utils/i2Math';

class ServiceCompletionAnalytics extends React.Component {
  /**
   * 获取原始数值
   * @param {*} value - 原始值
   * @returns {number} 数值
   */
  getRawValue(value) {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    const numValue = typeof value === 'number' ? value : parseFloat(value);
    return isNaN(numValue) ? 0 : numValue;
  }

  /**
   * 获取小数形式（用于 renderPerStr，需要 0-1 之间的值）
   * @param {*} value - 原始值
   * @returns {number} 小数形式（0-1）
   */
  getDecimalValue(value) {
    const rawValue = this.getRawValue(value);
    if (rawValue === 0) {
      return 0;
    }
    // 如果值大于1，说明是百分比形式（0-100），需要除以100
    // 如果值小于等于1，说明已经是小数形式（0-1），直接返回
    return rawValue > 1 ? i2Math.i2Division(rawValue, 100) : rawValue;
  }

  /**
   * 获取百分比数值（用于 Progress 组件，需要 0-100 之间的值）
   * @param {*} value - 原始值
   * @returns {number} 百分比数值（0-100）
   */
  getPercentageValue(value) {
    const decimalValue = this.getDecimalValue(value);
    // 使用 i2Math.i2Multiply 解决精度问题，将小数转换为百分比
    return i2Math.i2Multiply(decimalValue, 100);
  }

  render() {
    const { serviceCompletionRateSummaryObj } = this.props;
    const data = serviceCompletionRateSummaryObj?.data || {};
    const rawValue = data.overallCompletion;

    // 获取百分比数值（用于 Progress 组件）
    const percentValue = this.getPercentageValue(rawValue);

    // 计算填充的段数（使用 i2Math 解决精度问题）
    const totalSegments = 25;
    const segmentRatio = i2Math.i2Division(percentValue, 100);
    const filledSegments = Math.round(i2Math.i2Multiply(segmentRatio, totalSegments));

    return (
      <div className="service-completion-analytics">
        <div className="service-completion-header">
          <div className="service-completion-title">服务完成率</div>
          <div className="service-completion-percentage">
            {renderPerStr(rawValue)}
          </div>
        </div>
        <div className="service-completion-progress-container">
          <Progress
            percent={percentValue}
            strokeColor="#20b2aa"
            trailColor="#e0f7f5"
            showInfo={false}
            className="service-completion-progress"
          />
          <div className="service-completion-segments-overlay">
            {Array.from({ length: totalSegments }, (_, index) => (
              <div
                key={index}
                className={`service-completion-segment ${
                  index < filledSegments ? 'filled' : 'unfilled'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default ServiceCompletionAnalytics;

